import { trigger, transition, style, animate } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
	transition(':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
	transition(':leave', [animate('200ms', style({ opacity: 0 }))])
]);

export const slideInOut = trigger('slideInOut', [
	transition(':enter', [
		style({ transform: 'translateY(-100%)' }),
		animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
	]),
	transition(':leave', [animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))])
]);
